/**
 * Shared React Query options for dashboard metric reads.
 *
 * The dashboard mounts ~25 metric queries at once. With React Query's default
 * `staleTime` of 0 and `refetchOnWindowFocus` enabled, every remount and every
 * window refocus re-fires all of them, producing repeated request storms
 * against enrollio-be. These options treat dashboard aggregates as fresh for a
 * short window and stop refetching on focus.
 */
export const DASHBOARD_STALE_TIME_MS = 60_000;

export const dashboardQueryOptions = {
  staleTime: DASHBOARD_STALE_TIME_MS,
  refetchOnWindowFocus: false,
} as const;
